import Fields from "./CookieCalculatorFields";
import Result from "./CookieCalculatorResult";
import Description from "./CookieCalculatorDescription";
import calculate from "./calculate";
import Custom from "../customCalculator/CustomCalculatorFormContainer";

const CookieCalculator = { Description, Fields, Result, Custom, calculate };

export default CookieCalculator;
